import { Component, input, output } from '@angular/core';
import { IContactInfo } from '../models/contact.interface';

@Component({
  selector: 'contacts',
  styleUrls: ['./contacts.component.css'],
  templateUrl: './contacts.component.html',
  standalone: false,
})
export class ContactsComponent {
  readonly contactInfo = input<IContactInfo>({
    name: '',
    type: '',
    isAddBtn: false,
    listOperation: {},
    listItems: [],
    isPhoneNumber: false,
  });

  readonly emitContactEvent = output<unknown>();

  emitEvent(
    list: unknown,
    index: number,
    contactType: string,
    eventType: string,
  ) {
    const action = [];
    action.push(list);
    action.push(index);
    action.push(contactType);
    action.push(eventType);
    this.emitContactEvent.emit(action);
  }
}
